import { create } from "zustand";

import { CampaignSearchRequest } from "../api/campaign";

export interface CampaignSearchState {
  campaignName: string;
  campaignID: string;
  startDate: string;
  endDate: string;
  status: string;
}

type State = CampaignSearchState;

type Actions = {
  actions: {
    setState: (state: CampaignSearchState) => void;
  };
};

const CampaignSearchStore = create<State & Actions>(set => ({
  // State
  campaignName: "",
  campaignID: "",
  startDate: "",
  endDate: "",
  status: "Running",

  // Actions
  actions: {
    setState: newState =>
      set(() => ({
        ...newState,
      })),
  },
}));

export const useCampaignSearchStore = () => {
  return CampaignSearchStore(store => ({
    campaignName: store.campaignName,
    campaignID: store.campaignID,
    startDate: store.startDate,
    endDate: store.endDate,
    status: store.status,
  }));
};

export const useSetCampaignSearchStore = () => {
  return CampaignSearchStore(store => store.actions.setState);
};

type queryState = CampaignSearchRequest;

type ActionsQuery = {
  actions: {
    setQueryString: (queryString: CampaignSearchRequest) => void;
  };
};

const QueryCampaignSearchStore = create<queryState & ActionsQuery>(set => ({
  // State
  campaignName: "",
  campaignID: "",
  startDate: "",
  endDate: "",
  status: "",
  pagination: {
    currentPage: 1,
    pageSize: 10,
  },
  permission_Token: "",

  // Actions
  actions: {
    setQueryString: queryString =>
      set(() => ({
        ...queryString,
      })),
  },
}));

export const useCampaignSearchQuery = () =>
  QueryCampaignSearchStore(store => ({
    queryString: {
      campaignName: store.campaignName,
      campaignID: store.campaignID,
      startDate: store.startDate,
      endDate: store.endDate,
      status: store.status,
      pagination: {
        currentPage: store.pagination.currentPage,
        pageSize: store.pagination.pageSize,
      },
      permission_Token: store.permission_Token,
    },
    setQueryString: store.actions.setQueryString,
  }));
